import { FormBuilder } from '@piying/view-core';
import type { ReactSchemaHandle } from './schema-handle';

export class ReactFormBuilder extends FormBuilder<ReactSchemaHandle> {}
